/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.1.5
 */

export type ReportsFindAllSurveillanceType =
  (typeof ReportsFindAllSurveillanceType)[keyof typeof ReportsFindAllSurveillanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportsFindAllSurveillanceType = {
  active: 'active',
  passive: 'passive',
  other: 'other',
} as const;
